import { z } from 'zod';
/** Trims and normalizes blank form strings to undefined (omit on create). */
export const optionalFormString = () => z
    .string()
    .trim()
    .transform((value) => (value === '' ? undefined : value))
    .optional();
/** Trims and normalizes blank edit-form strings to null (explicit clear on update). */
export const optionalEditFormString = () => z
    .string()
    .trim()
    .transform((value) => (value === '' ? null : value))
    .optional()
    .nullable();
//# sourceMappingURL=optional-form-string.js.map